import React from "react";

export default class MapObjectOverlay extends React.Component {
    // new code (1) - begin
    constructor() {
        super();
        this.state = { };
    }

    componentDidMount() {
        const height = document.getElementById('overflow').clientHeight;
        const windowHeight = window.innerHeight
        this.setState({ height: height, windowHeight: windowHeight });
      }
    // new code (1) - end

    render () {
        const object = this.props.object;

        // old code (1) - begin
        // const style = {
        //     left: this.props.mousePosition.x,
        //     top: this.props.mousePosition.y,
        // };
        // old code (1) - end

        // new code (1) - begin
        if ((this.state.height + this.props.mousePosition.y) > this.state.windowHeight)
        {
            var style = {
                left: this.props.mousePosition.x,
                //top: this.props.mousePosition.y,
                bottom: 0            
            };
    
        }
        else {
            var style = {
                left: this.props.mousePosition.x,
                top: this.props.mousePosition.y,
                //bottom: 0            
            };    
        }
        // new code (1) - end

        return (
            <div id="overflow" className="cw-map-object-overlay" style={style}>
                <h4>{object.number}</h4>
                <table className="cw-object-info-table">
                    <tbody>
                    <tr>
                        <th>Våning:</th>
                        <td>{object.data['floor_number']}</td>
                    </tr>
                    <tr>
                        <th>Rum:</th>
                        <td>{object.data['rooms']} rok</td>
                    </tr>
                    <tr>
                        <th>Boarea:</th>
                        <td>{object.data['living_area']} m<sup>2</sup></td>
                    </tr>
                    {object.data['usp1'] &&
                    <tr>
                        <th>Inredningsval:</th>
                        <td>{object.data['usp1']}</td>
                    </tr>
                    }
                    {object.data['price'] &&
                    <tr>
                        <th>Pris:</th>
                        <td>{object.data['price'].formatted}</td>
                    </tr>
                    }
                    {object.data['monthly_fee'] &&
                    <tr>
                        <th>Avgift:</th>
                        <td>{object.data['monthly_fee'].formatted}</td>
                    </tr>
                    }
                    <tr>
                        <th>Status:</th>
                        <td>
                            <span className={'status-blob status-blob-' + object.status}></span> {object.status_name}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/components/MapObjectOverlay.jsx